{
  "name": "@ns/spreadsheet-onboarding-companies",
  "version": "1.0.0",
  "description": "Creating a spreadsheet to fulfil a job with multiple entities",
  "inputs": {},
  "outcomes": {
    "complete": {},
    "cancel": {}
  }
}
